import React, { useRef, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { FaAngleRight } from "react-icons/fa6";
import { BellIcon } from "../../asset/icons/Icon";
import { images, useOutsideClick } from "../../actions/customFn";
import { useDispatch, useSelector } from "react-redux";
import ProgressBar from "@ramonak/react-progress-bar";
import { AiOutlineClose } from "react-icons/ai";
import { setNotificationOpen } from "../../slice/notificationSlice";
import { FiMenu } from "react-icons/fi";
import MobileSidebar from "./MobileSidebar";
import CustomProgressBar from "./CustomProgressBar";

const Header = () => {
  const [open, setOpen] = useState(false);
  const handleToggle = () => {
    setOpen(!open);
  };

  const location = useLocation();

  const profileData = useSelector((state) => state.profileData.userData);
  const dispatch = useDispatch();
  const isNotification = useSelector(
    (state) => state.notificationData.isNotification
  );

  const video_notification = useSelector(
    (state) => state.notificationData.video_notification
  );

  const notificationRef = useRef(null);

  const closeWindow = (value) => {
    dispatch(setNotificationOpen(value));
  };

  useOutsideClick(notificationRef, closeWindow);

  // Check if there are any active uploads
  const hasActiveUploads = video_notification && 
    (Array.isArray(video_notification) ? 
      video_notification.some(notification => notification.uploadedpercent > 0 && notification.uploadedpercent < 100) :
      video_notification.uploadedpercent > 0 && video_notification.uploadedpercent < 100
    );

  function checkString(string) {
    var pattern = /\d/;
    if (pattern.test(string)) {
      return true;
    } else {
      return false;
    }
  }

  const PathStructure = () => {
    const pathArr = location.pathname.split("/");
    const pathArrObj = pathArr.map((path, i) => {
      if (path !== "") {
        if (checkString(path)) {
          return null;
        } else if (checkString(pathArr[i] + 1) === false) {
          return {
            text: path.toUpperCase(),
            url: window.location.origin + pathArr.slice(0, i + 1).join("/"),
          };
        } else if (checkString(pathArr[i + 1])) {
          return {
            text: path.toUpperCase(),
            url: window.location.origin + pathArr.slice(0, i + 2).join("/"),
          };
        } else {
          if (i === pathArr.length - 1) {
            return {
              text: path.toUpperCase(),
              url: window.location.origin + pathArr.slice(0, i + 1).join("/"),
            };
          } else {
            return {
              text: path.toUpperCase(),
              url: -1,
            };
          }
        }
      } else {
        return {
          text: "Home",
          url: window.location.origin + pathArr.slice(0, i + 1).join("/"),
        };
      }
    });
    let filterArr = pathArrObj.filter((val) => val !== null);
    if (location.pathname === "/") {
      filterArr = [{ text: "Home", url: window.location.origin }];
    }
    return filterArr;
  };

  const pathArr = PathStructure();

  return (
    <div className="header_container">
      <div className="header_breadcrumb">
        {pathArr?.length > 0 &&
          pathArr.map((data, i) => {
            return (
              <NavLink to={data.url} key={i}>
                <FaAngleRight />
                <span>{data.text}</span>
              </NavLink>
            );
          })}
      </div>
      <div className="header_profile_details">
        <div
          className={`header_profile_bellicon ${
            hasActiveUploads ? "active" : ""
          }`}
        >
          <div
            className="header_profile_bellicon_svg"
            onClick={() => dispatch(setNotificationOpen(true))}
          >
            <BellIcon />
          </div>
          {isNotification && (
            <NotificationCard
              notificationRef={notificationRef}
              video_notification={video_notification}
            />
          )}
        </div>
        <NavLink to={"/profile"}>
          <img
            alt=""
            src={profileData.image}
            className="header_profile_details_img"
          />
        </NavLink>
        <div className="header_profile_humberger">
          <FiMenu size={25} onClick={handleToggle} />
          {open ? <MobileSidebar open={open} setOpen={setOpen} /> : ""}
        </div>
      </div>
    </div>
  );
};

export default Header;

const NotificationCard = ({ notificationRef, video_notification }) => {
  // If video_notification is an array, get the most recent active upload
  const getActiveNotification = () => {
    if (!video_notification) return null;
    
    if (Array.isArray(video_notification)) {
      // Sort by uploadedpercent to get the most recent active upload
      const activeUploads = video_notification.filter(
        notification => notification.uploadedpercent > 0 && notification.uploadedpercent < 100
      );
      return activeUploads.length > 0 ? activeUploads[0] : null;
    }
    
    return video_notification.uploadedpercent > 0 && video_notification.uploadedpercent < 100 
      ? video_notification 
      : null;
  };

  const activeNotification = getActiveNotification();

  if (!activeNotification) {
    return (
      <div className="notification_card_container" ref={notificationRef}>
        <h6 className="text-center mb-3 mt-3">No Active Uploads</h6>
      </div>
    );
  }

  return (
    <div className="notification_card_container" ref={notificationRef}>
      <div className="notification_card_course">
        <div className="notification_card_course_title">
          <h4>{activeNotification.title}</h4>
        </div>
        <div className="notification_card_course_info">
          <span style={{color:"#000"}}>{Math.round(activeNotification.uploadedpercent)}% Uploaded</span>
          {(activeNotification.estimated_time_in_min > 0 || activeNotification.estimated_time_in_sec > 0)&& (
            <span style={{color:"#404040", display:"inline-block"}}>
              estimated time:{" "}
              {activeNotification.estimated_time_in_min > 0 &&
                `${activeNotification.estimated_time_in_min} minutes `}
              {activeNotification.estimated_time_in_sec > 0 &&
                `${activeNotification.estimated_time_in_sec} seconds `}
            </span>
          )}
        </div>
        <CustomProgressBar
          completed={Math.round(activeNotification.uploadedpercent)}
          height="15px"
          borderRadius="2px"
          isLabelVisible={false}
        />
      </div>
    </div>
  );
};
